// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "section.content-tc[data-v-d88c4f58]{padding:0 70px;max-height:600px;overflow:auto}section.content-tc p[data-v-d88c4f58],section.content-tc li[data-v-d88c4f58]{text-align:justify}@media only screen and (max-width: 767px){section.content-tc[data-v-d88c4f58]{padding:0 10px}}", ""]);
// Exports
module.exports = exports;
